export default {"src":"https://cdn2.e-farm.com/website-static/_next/static/media/ru.1f3c156a.svg","height":6,"width":9,"blurWidth":0,"blurHeight":0};